export interface ITripRateChartDataset {
    label: string;                   
    data: Array<number | null>;
    borderColor?: string;            
    backgroundColor?: string;        
    borderWidth?: number;            
}

export interface ITripRateChartData {
    title: string;                   
    xAxisTitle: string;              
    yAxisTitle: string;              
    labels: string[];                
    datasets: ITripRateChartDataset[];
}

export default class ExportTripRateLineGraphViewModel {
    exportType: "PDF" | "CSV" | "JPEG" = "PDF";
    addUserComments: boolean = false;
    userComment: string | null = null;
    displayToScreen: boolean = true;
    fileName: string = "";
    chartData?: ITripRateChartData | null;
    selectedParam: number = 0;
    mainUse: string = "";
    subUse: string = "";
}
